
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/poluchite-bez-bankov",
      function () {
        return require("private-next-pages/poluchite-bez-bankov.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/poluchite-bez-bankov"])
      });
    }
  